let sharedCtx = null;

function getContext() {
  if (!sharedCtx) {
    sharedCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return sharedCtx;
}

document.addEventListener('click', () => {
  if (sharedCtx && sharedCtx.state === 'suspended') sharedCtx.resume();
}, { passive: true });

// Ayarlar sayfasında seçilen ses tipi ve seviyesi (bu cihazın tarayıcısında saklanır).
export const SOUND_TYPES = [
  { key: 'default', label: 'Bip' },
  { key: 'bell', label: 'Zil' },
  { key: 'chime', label: 'Çan' },
  { key: 'alarm', label: 'Alarm (3 kez)' },
];

const readLS = (key, fallback) => { try { return localStorage.getItem(key) ?? fallback; } catch { return fallback; } };
export const getSoundType = () => readLS('orderSoundType', 'default');
export const getSoundVolume = () => {
  const v = Number(readLS('orderSoundVolume', '60'));
  return Number.isFinite(v) ? Math.min(100, Math.max(0, v)) : 60;
};

// Tek bir notalı ses parçası: [frekans, başlangıç sn] listesi.
const PATTERNS = {
  default: { wave: 'sine', notes: [[880, 0], [660, 0.1], [880, 0.2]], length: 0.45 },
  bell: { wave: 'sine', notes: [[1047, 0], [1319, 0.1], [1047, 0.2]], length: 0.45 },
  chime: { wave: 'triangle', notes: [[523, 0], [659, 0.15], [784, 0.3]], length: 0.5 },
  alarm: { wave: 'square', notes: [[988, 0], [740, 0.12]], length: 0.28, repeat: 3, gap: 0.12 },
  cancel: { wave: 'sine', notes: [[660, 0], [440, 0.15], [330, 0.3]], length: 0.45 },
};

function playPattern(ctx, pattern, startAt, peak) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = pattern.wave;
  osc.connect(gain);
  gain.connect(ctx.destination);
  pattern.notes.forEach(([freq, at]) => osc.frequency.setValueAtTime(freq, startAt + at));
  gain.gain.setValueAtTime(peak, startAt);
  gain.gain.exponentialRampToValueAtTime(0.001, startAt + pattern.length);
  osc.start(startAt);
  osc.stop(startAt + pattern.length);
}

export async function playBeep(type = 'new', override = {}) {
  try {
    const volume = override.volume ?? getSoundVolume();
    if (volume <= 0) return;
    const ctx = getContext();
    if (ctx.state === 'suspended') await ctx.resume();

    const key = type === 'cancel' ? 'cancel' : (override.soundType ?? getSoundType());
    const pattern = PATTERNS[key] || PATTERNS.default;
    // Kare dalga daha sert duyulur; aynı seviyede kulağı yormasın diye kısılır.
    const peak = Math.max(0.001, (volume / 100) * (pattern.wave === 'square' ? 0.25 : 0.6));
    const repeat = pattern.repeat || 1;
    for (let i = 0; i < repeat; i += 1) {
      playPattern(ctx, pattern, ctx.currentTime + i * (pattern.length + (pattern.gap || 0)), peak);
    }
  } catch (e) {
    console.error('Ses çalınamadı:', e);
  }
}
